<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { FIELD_CLASS } from '../constants';
import { STEP_DEFS } from '../ticketHelpers';
import FormField from './FormField.vue';

const TEXT_MAX = 2000;

// Asks for what a step needs before it is sent: a required reason (cancel,
// reopen, hand back) or an optional note to the tenant (mark resolved). The
// page makes the call, so a refusal (a note with a phone number, a future
// visit) can be shown here: it passes the message back in `error`.
export default {
  name: 'StepModal',
  components: { BaseModal, FormField },
  props: {
    step: { type: String, required: true },
    error: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      fieldClass: FIELD_CLASS,
      text: '',
      showRequired: false,
    };
  },
  computed: {
    needs() {
      return STEP_DEFS[this.step].needs;
    },
    isReason() {
      return this.needs === 'reason';
    },
    max() {
      return TEXT_MAX;
    },
  },
  methods: {
    onSubmit() {
      if (this.isReason && !this.text.trim()) {
        this.showRequired = true;
        return;
      }
      this.$emit(
        'confirm',
        this.isReason ? { reason: this.text } : { note: this.text }
      );
    },
  },
};
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>
      {{ $t(`CO_LIVING.TICKETS.STEPS.${step.toUpperCase()}`) }}
    </template>

    <form
      class="grid grid-cols-1 gap-4"
      data-testid="co-living-step-form"
      @submit.prevent="onSubmit"
    >
      <FormField
        :label="
          $t(
            isReason
              ? 'CO_LIVING.TICKETS.STEP_MODAL.REASON'
              : 'CO_LIVING.TICKETS.STEP_MODAL.NOTE'
          )
        "
        for-id="co-living-step-text"
        :error="
          showRequired && isReason && !text.trim()
            ? $t('CO_LIVING.TICKETS.STEP_MODAL.REASON_REQUIRED')
            : error
        "
        :hint="
          $t(
            isReason
              ? 'CO_LIVING.TICKETS.STEP_MODAL.REASON_HINT'
              : 'CO_LIVING.TICKETS.STEP_MODAL.NOTE_HINT'
          )
        "
      >
        <textarea
          id="co-living-step-text"
          v-model="text"
          rows="4"
          :maxlength="max"
          :class="fieldClass"
          data-testid="co-living-step-text"
        />
      </FormField>

      <div class="flex justify-end gap-3">
        <woot-button variant="clear" type="button" @click="$emit('close')">
          {{ $t('CO_LIVING.COMMON.CANCEL') }}
        </woot-button>
        <woot-button
          type="submit"
          :is-loading="isLoading"
          data-testid="co-living-step-confirm"
        >
          {{ $t(`CO_LIVING.TICKETS.STEPS.${step.toUpperCase()}`) }}
        </woot-button>
      </div>
    </form>
  </BaseModal>
</template>
